export const FETCH_ROOMS_REQUEST = 'FETCH_ROOMS_REQUEST'
export const FETCH_ROOMS_SUCCESS = 'FETCH_ROOMS_SUCCESS'
export const FETCH_ROOMS_FAILURE = 'FETCH_ROOMS_FAILURE'
export const UPDATE_SELECTED_ROOM = 'UPDATE_SELECTED_ROOM'

export const CREATE_ROOM_REQUEST = 'CREATE_ROOM_REQUEST'
export const CREATE_ROOM_SUCCESS = 'CREATE_ROOM_SUCCESS'
export const CREATE_ROOM_FAILURE = 'CREATE_ROOM_FAILURE'

export const DELETE_ROOM_REQUEST = 'DELETE_ROOM_REQUEST'
export const DELETE_ROOM_SUCCESS = 'DELETE_ROOM_SUCCESS'
export const DELETE_ROOM_FAILURE = 'DELETE_ROOM_FAILURE'
